// PE-30 — the ONE definition of "the next set row repeats the last one".
//
// It existed twice, by hand and NOT identically: `addSetRow` blanked the new
// row's notes, while `buildPayload`'s save-time superset padding spread the
// whole row (`{ ...last, cells }`) and so copied the previous set's note text
// AND its stored translations onto a row nobody had written. Two copies of a
// rule that can disagree is the worst kind of duplicate — the disagreement is
// invisible until the paths run in a different order.
//
// ⛔ Lives in its own module, not in programEdit.ts: programEditBuild.ts
// deliberately imports only TYPES from there to keep the runtime import
// cycle-free (see that file's header), and this is a runtime function.
import type { CellDraft, SetRowDraft } from "./programEdit.js";

export const seedNextSetRow = (last: SetRowDraft): SetRowDraft => ({
  intensityKind: last.intensityKind,
  // ⚠️ workKind is on the ROW while the seconds are on the CELL, and the cell
  // copy below already carries them. Omitting it left the new set holding a
  // duration inside a row that no longer claimed to be timed.
  ...(last.workKind ? { workKind: last.workKind } : {}),
  cells: last.cells.map((c) => ({ ...c })),
  // A NEW set inherits no note, so it inherits no stored translation either —
  // grafting the previous set's words onto it would attribute them to a set
  // nobody wrote them for.
  notesPerCell: last.notesPerCell.map(() => ""),
});

// #283: moved here from programEdit.ts so programEditRead.ts can import the
// VALUES without a runtime cycle (programEdit re-exports Read).
export const blankCell = (): CellDraft => ({ reps: "5", intensityValue: "70" });

export const blankSetRow = (cycleWeeks: number): SetRowDraft => ({
  intensityKind: "percent-of-max",
  cells: Array.from({ length: cycleWeeks }, blankCell),
  notesPerCell: Array.from({ length: cycleWeeks }, () => ""),
});
